import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/manga';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/hanman-fu', label: '韩漫腐' },
    { to: '/category/hanman-danmei', label: '韩漫耽美' },
    { to: '/category/riman-fu', label: '日漫腐' },
    { to: '/category/guoman-danmei', label: '国漫耽美' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap group">
          <span className="text-2xl font-display text-accent-500 group-hover:text-accent-600 transition-colors">
            {siteInfo.name}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === link.to
                  ? 'text-accent-600 bg-accent-100/80'
                  : 'text-foreground-700 hover:text-accent-600 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 pb-4">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`block px-3 py-3 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === link.to
                  ? 'text-accent-600 bg-accent-100/80'
                  : 'text-foreground-700 hover:text-accent-600 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}